import { connect } from 'react-redux';
import {
    addOrderPosition,
    increaseQuantity,
    decreaseQuantity,
    selectMenuPositionConfigurator,
    clearSelectedMenuPosition,
    selectIsOrderPositionAdded,
    selectOrderContext,
    selectAddOrderPositionError,
    clearAddOrderPositionErrorMessage,
    selectShouldCreateNewOrder
} from 'src/modules/Order';

import { dismissFirstMessage } from 'src/modules/Modal';

import { pushNotification } from 'src/modules/Notification';

const mapDispatchToProps = {
    addOrderPosition,
    increaseQuantity,
    decreaseQuantity,
    clearSelectedMenuPosition,
    dismissFirstMessage,
    pushNotification,
    clearAddOrderPositionErrorMessage
};

const mapStateToProps = (state) => ({
    configurablePosition: selectMenuPositionConfigurator(state),
    isOrderPositionAdded: selectIsOrderPositionAdded(state),
    context: selectOrderContext(state),
    addOrderPositionError: selectAddOrderPositionError(state),
    shouldCreateNewOrder: selectShouldCreateNewOrder(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
